import { Badge } from '@/components/ui/badge';
import type { CsrLeadClass } from '@/types/reports';

/** Shared by the CSR leaderboard's expanded rows and the KPI drill-down sheet. */
const CLASS_BADGE: Record<CsrLeadClass, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
  booked: { label: 'Booked', variant: 'default' },
  lost_csr: { label: 'Lost', variant: 'destructive' },
  open: { label: 'Open', variant: 'secondary' },
  excluded: { label: 'Excluded', variant: 'outline' },
  lost_ops: { label: 'Lost to ops', variant: 'outline' },
};

const JOB_STATUS_BADGE: Record<string, { label: string; className: string }> = {
  completed: { label: 'Completed', className: 'border-success/40 text-success' },
  cancelled: { label: 'Cancelled', className: 'border-destructive/40 text-destructive' },
  scheduled: { label: 'Scheduled', className: '' },
  in_progress: { label: 'In progress', className: '' },
  on_hold: { label: 'On hold', className: 'border-warning/40 text-warning' },
  quote_sent: { label: 'Quote sent', className: '' },
};

export function ClassBadge({ cls }: { cls: CsrLeadClass }) {
  const meta = CLASS_BADGE[cls];
  return <Badge variant={meta.variant} className="text-xs">{meta.label}</Badge>;
}

export function JobStatusBadge({ status }: { status: string | null }) {
  if (!status) return <span className="text-muted-foreground">-</span>;
  const meta = JOB_STATUS_BADGE[status] ?? { label: status, className: '' };
  return <Badge variant="outline" className={`text-xs ${meta.className}`}>{meta.label}</Badge>;
}
